import { Branding } from './branding.model';

/**
 * What a customer must supply to open a shared inspection report link.
 *
 * Mirrors the server enum. Drives which prompt the login page shows and nothing else: the server
 * decides what it will accept from the tenant setting and the record, so changing this value, or the
 * query string, cannot move a link between modes.
 */
export enum ReportLinkVerification {
    None = 'None',
    Registration = 'Registration',
    Code = 'Code',
}

/**
 * What the anonymous login page needs to render itself: which credential to ask for, and the
 * retailer's branding to ask for it in.
 */
export interface AccessCodeLoginContext extends Branding {
    verification: ReportLinkVerification;
}
